import React from "react";
import {Rnd} from "react-rnd";
import iconClose from "images/ic_close.svg";
import styles from "./index.module.scss";
import {useGetAssetsInfiniteQuery, useInterSectionObserver} from "hooks";
import {useGetStudioMode} from "components/Layout/hooks";

const PropertyLibrary = ({name, propertyName, onClickItem, onClickClose}) => {
  const {isEditMode} = useGetStudioMode();

  const params =
    name === "Particle Texture"
      ? {
          publicStatus: true,
          topCategory: "IMAGE",
          subCategory: "PARTICLEMAP",
        }
      : {
          publicStatus: true,
          topCategory: "IMAGE",
          midCategory: "TEXTURE",
          subCategory: name.toUpperCase().replace(" ", ""),
        };

  const {data, fetchNextPage, hasNextPage} = useGetAssetsInfiniteQuery(params);

  const [, loadingRef] = useInterSectionObserver(fetchNextPage, {});

  if (!isEditMode) return null;
  return (
    <Rnd
      default={{
        x: -360,
        y: -280,
        width: 262,
        height: 424,
      }}
      minWidth="262"
      minHeight="424"
      dragHandleClassName={styles.header}
    >
      <div className={styles.property_library}>
        <div className={styles.header}>
          <p>{propertyName}</p>
          <img className={styles.header_close} src={iconClose} alt="close" onClick={onClickClose} onTouchEnd={onClickClose} />
        </div>
        <ul className={styles.library_item}>
          {data?.pages?.map((page, idx) => (
            <div className={styles.library_item} key={idx}>
              {page?.map(asset => (
                <div className={styles.item_wrap}>
                  <img
                    src={asset.url}
                    alt="asset_img"
                    onClick={() => {
                      onClickItem(name, asset.url);
                    }}
                  />
                  <p className={styles.library_item_title}>{asset.name}</p>
                </div>
              ))}
            </div>
          ))}
          {hasNextPage && <div className={styles.load_more} ref={loadingRef} />}
        </ul>
      </div>
    </Rnd>
  );
};

export default PropertyLibrary;
